import React from 'react';
import { InventorySupplierSummaryCounts } from '@/renderer/types/inventory';

export function SuppliersSummaryCards({
  summary,
}: {
  summary: InventorySupplierSummaryCounts;
}) {
  const cards = [
    { label: 'Total suppliers', value: summary.totalSuppliers },
    { label: 'Active', value: summary.activeSuppliers },
    { label: 'Inactive', value: summary.inactiveSuppliers },
    {
      label: 'With opening balance',
      value: summary.suppliersWithOpeningBalance,
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="rounded-2xl border border-gray-200 bg-white px-4 py-4 shadow-sm"
        >
          <p className="text-sm text-gray-500">{card.label}</p>
          <p className="mt-2 text-2xl font-semibold text-gray-900">
            {card.value.toLocaleString()}
          </p>
        </div>
      ))}
    </div>
  );
}
